module.exports = __webpack_public_path__ + "e83ba7bd1061ff4c7d99f7a4cc829420.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprite.png
// module id = EmMn
// module chunks = 0